import { InjectionToken } from '@angular/core';

/**
 * API Configuration interface
 */
export interface ApiConfig {
  baseUrl: string;
  apiVersion?: string;
  timeout?: number;
}

/**
 * Default API configuration
 * NOTE: This is a fallback only. Applications should provide API_CONFIG using environment configuration.
 */
export const DEFAULT_API_CONFIG: ApiConfig = {
  baseUrl: '', // Empty - should be provided via API_CONFIG injection token
  apiVersion: 'v1',
  timeout: 30000, // 30 seconds
};

/**
 * Injection token for API configuration
 */
export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG');

